import { useQuery } from '@tanstack/react-query'
import { FloorPlanAPI, floorPlanToStore } from '@/features/floor-plan'

/**
 * The venue's rooms and tables, read only.
 *
 * Deliberately NOT `useFloorPlanQuery`. That hook exists to hydrate the
 * planner: it writes the plan into the planner's store, tracks what has been
 * saved and decides when local work may be discarded. Calling it from here to
 * fill a dropdown would reach across a feature boundary and could throw away
 * tables somebody had dragged around and not yet saved.
 *
 * This asks the same endpoint through the same client and the same mapper, and
 * then does nothing else with the answer.
 */
export function useRestaurantRooms() {
  // The endpoint is prefixed with the restaurant, so the cache is scoped to it
  // too; without that, switching venue would serve the previous one's rooms.
  const restaurantId =
    typeof localStorage !== 'undefined'
      ? localStorage.getItem('restaurantId')
      : null

  const { data, isLoading } = useQuery({
    queryKey: ['website-builder', 'venue-rooms', restaurantId],
    enabled: !!restaurantId,
    queryFn: async () => floorPlanToStore(await FloorPlanAPI.getFloorPlan())
  })

  return {
    rooms: data?.rooms ?? [],
    tables: data?.tables ?? [],
    isLoading
  }
}

export default useRestaurantRooms
